//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters, mapState} from 'vuex'

export default {
  name: 'Currencies',
  props: {
  },
  computed: {
    ...mapGetters([
      'vcListNoSettleEnabled'
    ]),
    ...mapState({
      coinListWithPrice: state => state.vc.coinListWithPrice
    }),
    hotCoinList () {
      if (!this.coinListWithPrice.length) return []
      return this.vcListNoSettleEnabled.map(settleItem => {
        return this.coinListWithPrice.find(coinWithPriceItem => {
          return settleItem.id === coinWithPriceItem.a
        })
      }).filter(item => !!item)
    }
  },
  methods: {
    clickVcItem (currency) {
      this.$store.dispatch('setVcId', currency.a)
        .then(() => {
          this.$router.push('/trade')
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/components/HotCoins/HotCoins.vue